import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  withStyles
} from '@material-ui/core';
import React from 'react';
import { t } from '../../commons/Translate.js'

const SortBySelect = withStyles({
  formControl: {
    minWidth: '253px'
  }
})(({sortBy, onChange, perspective, classes}) => {
  perspective = perspective || 'recipient'
  return <FormControl className={classes.formControl}>
    <InputLabel>{t('Sortieren nach')}</InputLabel>
    <Select value={sortBy} onChange={onChange}>
      <MenuItem value={'validUntil'}>{t('Abzuschließen bis (aufsteigend)')}</MenuItem>
      <MenuItem value={'-validUntil'}>{t('Abzuschließen bis (absteigend)')}</MenuItem>
      <MenuItem value={'task.title'}>{t('Fall')}</MenuItem>
      <MenuItem value={'student.lastName,student.firstName'}>{t('Student:in')}</MenuItem>
      { perspective === 'creator' ? <MenuItem value={'assignedTo.name'}>{t('Beauftragte Person')}</MenuItem> : null }
      { perspective === 'recipient' ? <MenuItem value={'assignedBy.name'}>{t('Auftrag von')}</MenuItem> : null }
    </Select>
  </FormControl>
})

export default SortBySelect